<template>
  <Button
    v-bind="$attrs"
    label="ยกเลิกเอกสาร"
    icon="pi pi-times"
    class="p-button-danger"
    @click="onCancel"
  ></Button>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { usePlugin } from "@/plugins";

export default defineComponent({
  name: "CancelButton",
  emits: ["cancel"],
  setup(_, { emit }) {
    const { confirmation } = usePlugin();

    const onCancel = () => {
      confirmation.require({
        header: "ยกเลิกเอกสาร",
        message: "กรุณายืนยันเพื่อทำการยกเลิกเอกสาร?",
        acceptLabel: "ยืนยัน ยกเลิกเอกสาร",
        rejectLabel: "ปิด",
        acceptClass: "p-button-danger",
        accept: () => {
          emit("cancel");
        },
      });
    };
    return { onCancel };
  },
});
</script>

<style></style>
